// Module
var code = "<template class=\"header-button-wrap ${activated ? 'activated' : '' & oneWay} ${selected ? 'selected' : '' & oneWay}\"> <require from=\"./header-button.scss\"></require> <button class=\"header-button\" type=\"button\" click.delegate=\"click({ e: $event })\"> <slot></slot> </button> </template> ";
// Exports
export default code;